var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ParagraphBody } from '../../paragraphs';
import { FooterLink } from '../../molecules/navigation';
import { useEffect, useState } from 'react';
import { DynamicFooterStyled as FooterStyled } from './DynamicFooter.styled';
export var DynamicFooter = function (_a) {
    var _b, _c;
    var links = _a.links, text = _a.text, _d = _a.className, className = _d === void 0 ? '' : _d, tabFocusTrap = _a.tabFocusTrap, _e = _a.hideStickyPricing, hideStickyPricing = _e === void 0 ? true : _e, _f = _a.forceRelative, forceRelative = _f === void 0 ? false : _f;
    var _g = useState(window.innerHeight), screenHeight = _g[0], setScreenHeight = _g[1];
    var pageHeight = ((_b = document.getElementById('pages-wrapper')) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
    var handleResize = function () {
        setScreenHeight(window.innerHeight);
    };
    useEffect(function () {
        window.addEventListener('resize', handleResize, false);
    }, []);
    var footerHeight = ((_c = document.getElementById('footer-container')) === null || _c === void 0 ? void 0 : _c.offsetHeight) || 0;
    var fixedFooter = screenHeight - footerHeight > pageHeight;
    return (_jsx(FooterStyled, __assign({ className: className, fixedFooter: fixedFooter, hideStickyPricing: hideStickyPricing, forceRelative: forceRelative }, { children: _jsxs("div", __assign({ id: "footer-container", className: "container" }, { children: [_jsx("div", __assign({ className: "links" }, { children: links.map(function (link, key) { return (_jsx("span", { children: _jsx(FooterLink, __assign({ tabIndex: tabFocusTrap, onClick: link.tracking, target: "_blank", rel: "noreferrer", href: link.href }, { children: link.label })) }, key)); }) })), _jsx(ParagraphBody, { children: text })] })) })));
};
